import React, { FC } from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import BenefitsIcon from '@/assets/icons/BenefitsIcon'
import { formatCurrency } from '@/utils/general/browserHelper'
import { FareType } from '@/types/srp'
import { getFFBottomCallout } from '@/utils/srp'
import { CT_UPGRADE_BENEFIT_TYPE } from '@/utils/flights/smbVasCoupon'
import PriceBenefitsInfo from './PriceBenefitsInfo'
import CtUpgrade from '@/assets/logo/CtUpgrade'

interface FareCardBottomCallout {
    fare: FareType
}

const FareCardBottomCallout: FC<FareCardBottomCallout> = ({ fare }) => {
    const calloutDetails = getFFBottomCallout(fare)
    if (!calloutDetails) return null

    const { additionalBenefitsWorth, benefitText, benefitType } = calloutDetails

    if (additionalBenefitsWorth && benefitType !== CT_UPGRADE_BENEFIT_TYPE) return <PriceBenefitsInfo price={additionalBenefitsWorth} />

    if (benefitType === CT_UPGRADE_BENEFIT_TYPE)
        return (
            <Container
                className="flex flex-center flex-middle flex-gap-1"
                css={{
                    background: 'linear-gradient(89.99deg, #FFF1EC 0.01%, rgba(254, 222, 213, 0) 80.18%)',
                    paddingBottom: '8px',
                    paddingTop: '22px',
                    marginTop: '-12px',
                    flexGrow: 1,
                    borderBottomLeftRadius: '16px',
                    borderBottomRightRadius: '16px'
                }}
            >
                <CtUpgrade/>
                <Typography variant="P3" className="ws-nowrap">
                    {benefitText}
                </Typography>
            </Container>
        )

    // if (calloutType === 'freeTag')
    //     return (
    //         <Container
    //             className="flex flex-center"
    //             css={{
    //                 backgroundColor: '#ECF3FF',
    //                 paddingBottom: '8px',
    //                 paddingTop: '22px',
    //                 marginTop: '-12px',
    //                 flexGrow: 1,
    //                 borderBottomLeftRadius: '16px',
    //                 borderBottomRightRadius: '16px'
    //             }}
    //         >
    //             <Typography variant="P3" className="ws-nowrap">
    //                 {benefitText}
    //             </Typography>
    //         </Container>
    //     )
}

export default FareCardBottomCallout
